<template>
  <div>
    <select class="common_select" @change="onChange">
      <option v-for="(item, n) in items" :key="n" :value="item.course_id" :selected="item.selected">
        {{item.name}}
      </option>
    </select>
  </div>
</template>

<script>
import UT from '@/common/util';

export default {
  name: "SelectCourse",
  props: {
    value: Object,
    year: String,
    semester: String
  },
  data: () => ({
    items: [],
  }),
  computed: {
  },
  methods: {
    onChange(evt) {
      this.items.forEach((item, i) => {
         item.selected = i === evt.srcElement.selectedIndex ? true : false;
      });
      this.changed();
    },
    changed() {
      let selected = this.items.filter((item) => {
        return item.selected;
      });
      this.$emit("input", selected[0]);
    },
    selectCourse(course_id, callback) {
      this.items.forEach((item) => {
        item.selected = (item.course_id === course_id ? true : false);
      });
      this.changed();
      callback();
    },
    requesItems() {
      let me = this;
      let req = {
        url: '/api/user/course-list',
        data: {
          year: this.year,
          semester: this.semester,
          user_id: this.$session.get("user_id")
        }
      };
      UT.api(req).then((res) => {
        this.items = [];
        this.items.push({
          name: this.$i18n.translate('선택해주세요'),
          course_id: '',
          course_cd: '',
          selected: true
        });
        if (res.data && res.data.result) {
          let list = res.data.result;
          for (let i = 0; i < list.length; i++) {
            this.items.push({
              name: list[i].coursename,
              course_id: `${list[i].course_id}`,
              course_cd: `${list[i].course_cd}`,
              selected: false
            });
          }
        }
        me.$emit("loaded");
        this.changed();
      });
    }
  },
  created() {
    this.requesItems();
  },
  beforeMount() {
    let me = this;
    this.items.forEach((item) => {
      item.selected = (item.course_id === me.value.course_id ? true : false);
    });
  },
  watch: {
    year() {
      this.requesItems();
    },
    semester() {
      this.requesItems();
    }
  }
}
</script>
